import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { LayoutFullWidthSettings } from './models/layout-full-width.models';


export const LayoutFullWidthDefinition: IdtComponentDefinition = {
  id: 'layout-full-width',
  role: IdtComponentRole.Layout,
  numSlots: 1,
  defaultSlot: 1
};

export const LayoutFullWidthCmsDefinition: IdtComponentCmsDefinition = {
  name: '1 columna',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): LayoutFullWidthSettings => {
    return {
      general: {},
      styles: {
        shadow: 'none',
        responsiveConfig: []
      }
    };
  }
};
